// Shared helpers
export const pingColor = (ping) => {
  if (ping < 50) return "var(--ping-great)";
  if (ping < 100) return "var(--ping-good)";
  if (ping < 200) return "var(--ping-med)";
  return "var(--ping-high)";
};

export const pingLabel = (ping) => {
  if (ping < 50) return "Optimal";
  if (ping < 100) return "Good";
  if (ping < 200) return "Moderate";
  return "High";
};

export const pingBars = (ping) => {
  if (ping < 50) return 4;
  if (ping < 100) return 3;
  if (ping < 200) return 2;
  return 1;
};

export const formatNumber = (n) => {
  if (n == null) return "—";
  return n.toLocaleString("en-US");
};

export const timeAgo = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  const secs = Math.floor((Date.now() - d.getTime()) / 1000);
  if (secs < 60) return `${secs}s ago`;
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  return `${days}d ago`;
};

export const formatHours = (h) => {
  if (h == null) return "—";
  if (h < 24) return `${h}h`;
  const d = Math.floor(h / 24);
  const r = h % 24;
  return r ? `${d}d ${r}h` : `${d}d`;
};

// Human-readable duration from minutes: "47m", "2h 15m", "1d 3h".
export const formatDuration = (totalMins) => {
  if (totalMins == null) return "—";
  if (totalMins < 1) return "<1m";
  if (totalMins < 60) return `${totalMins}m`;
  const hrs = Math.floor(totalMins / 60);
  const mins = totalMins % 60;
  if (hrs < 24) return mins ? `${hrs}h ${mins}m` : `${hrs}h`;
  const days = Math.floor(hrs / 24);
  const r = hrs % 24;
  return r ? `${days}d ${r}h` : `${days}d`;
};

// Short compact variant for inline tags like "LAST 14m AGO"
export const lastSeenShort = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  const secs = Math.floor((Date.now() - d.getTime()) / 1000);
  if (secs < 60) return "JUST NOW";
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m AGO`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h AGO`;
  const days = Math.floor(hrs / 24);
  return `${days}d AGO`;
};
